/**
 * Created by matheusmorett on 23/08/18.
 */
import Card from './Card';
export default Card;
